import MobileDetails from "./MobileDetails.vue";

const mobileDetailsCtrl = new Vue({
    el: '#mobile-details',
    components: {MobileDetails}
});
